import axios from 'axios'
import { handleSessionExpired } from '@/events/sessionExpiry'
import { shouldMarkRequestAsActivity, syncSessionFromResponse } from '@/composables/useSessionTimeout'

const $axios = axios.create({
  baseURL: process.env.VITE_API_BASE_URL || '/api',
})

export const markAsBackgroundPolling = (config = {}) => ({
  ...config,
  skipSessionActivity: true,
})

$axios.interceptors.request.use(
  async config => {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    config.headers['X-CSRF-TOKEN'] = csrfToken

    const accessToken = localStorage.getItem('token')
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    if (accessToken && !config.skipSessionActivity && shouldMarkRequestAsActivity())
      config.headers['X-User-Activity'] = '1'

    return config
  },
  error => {
    return Promise.reject(error)
  },
)

$axios.interceptors.response.use(
  response => {
    syncSessionFromResponse(response)

    return response.data
  },
  error => {
    if (error.response?.status === 401) {
      handleSessionExpired({
        message: error.response?.data?.message || 'Your session has expired. Please log in again.',
      })
    }

    return Promise.reject(error)
  },
)


export default $axios
